module.exports = __webpack_public_path__ + "media/images/company_logo/logo_sms-1d076ad2877d921649965e93893b0872.jpg";